import { render, staticRenderFns } from "./firstIndex.vue?vue&type=template&id=fce7fcb0&scoped=true"
import script from "./firstIndex.vue?vue&type=script&lang=js"
export * from "./firstIndex.vue?vue&type=script&lang=js"
import style0 from "./firstIndex.vue?vue&type=style&index=0&id=fce7fcb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce7fcb0",
  null
  
)

export default component.exports